import api from '../../services/pipelineStageSubmitted';
export default function (helper) {

    /**
     * Generated store module
     */
    helper.setApi(api);
    const types = helper.types('pipeline_stages_submitted');
    const state = helper.state();
    const getters = helper.getters();
    const actions = helper.actions({}, 'Submitted Pipeline Stages');
    const mutations = helper.mutations({}, types, state);

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
}